import React from 'react'
import { useMultiStyleConfig } from '@chakra-ui/system'
import { Spinner, SpinnerProps as ChakraSpinnerProps } from '@chakra-ui/react'
import { Icon } from '../Icon/Icon'
import { Box } from '../Box/Box'
import { SwashbuckleComponentProps } from '../../types'

type OmittedSpinnerProps = 'colorScheme' | 'emptyColor' | 'speed' | 'thickness'

type SpinnerProps = {
  variant?: 'default' | 'bot-head'
  delay?: string
  size?: 'sm' | 'md' | 'lg'
} & Omit<SwashbuckleComponentProps<ChakraSpinnerProps>, OmittedSpinnerProps>

export const LoadingSpinner = ({
  'data-qa': dataQa,
  className,
  variant,
  delay = '0ms',
  ...chakraSpinnerProps
}: SpinnerProps) => {
  // Had a ton of problems typing this
  const styles: any = useMultiStyleConfig('Spinner', {
    delay,
    variant,
    ...chakraSpinnerProps,
  })

  return (
    <Box
      position='relative'
      __css={styles.container}
      data-qa={dataQa}
      className={className}
    >
      <Spinner {...styles.spinner} {...chakraSpinnerProps} thickness='3px' />
      {variant === 'bot-head' && (
        <Box
          position='absolute'
          transform={`translate(-50%, -50%)`}
          top='50%'
          left='50%'
        >
          <Icon name='bot-head' title='Homebot logo' {...styles.icon} />
        </Box>
      )}
    </Box>
  )
}

LoadingSpinner.displayName = 'LoadingSpinner'
